import { takeLatest, put, call,take } from 'redux-saga/effects';
import request from '../../components/Utils/httpHelper';
import * as ifscMasterActions from './action';
import { CORE_API } from '../../config';
import { HTTP_HEADERS, HTTP_HEADERS_FORMDATA, HTTP_RESPONSE_TYPE_ARRAYBUFFER } from '../../constants'
import { DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE } from './IfscMasterTable/constants';

export function* ifscMasterTemplateRequest(action) {
    let requestURL = `${CORE_API}/ifsc/master/template/download`;

    try {
        const data = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(ifscMasterActions.ifscMasterTemplateSuccess({ data: data.data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(ifscMasterActions.ifscMasterTemplateFailure({ ...err.response, status: "FAILURE" }))
    }
}

export function* ifscMasterTemplate() {
    yield takeLatest(ifscMasterActions.IFSC_MASTER_TEMPLATE_REQUEST, ifscMasterTemplateRequest);
}

export function* submitIfscMasterRequestSaga(action) {
    const formData = new FormData();
    formData.append('ifscMasterExcelFile', action.data.file);
    let requestUrl = "";
    let methodtype = "";
    if(action.data.type === 'add'){
        methodtype="POST"
        requestUrl = `${CORE_API}/ifsc/master/add`;
    }
    if(action.data.type === 'edit'){
         methodtype="PUT"
        requestUrl = `${CORE_API}/ifsc/master/update`;
    }
    try {
        const searchResult = yield call(request, requestUrl, { data: formData, method: methodtype, headers: HTTP_HEADERS_FORMDATA });
        yield put(ifscMasterActions.addIfscMasterUploadSuccess(searchResult.data));
    } catch (err) {
        yield put(ifscMasterActions.addIfscMasterUploadFailure({ ...err.response, status: "FAILURE" }))
    }
}
export function* submitIfscMasterRequest() {
    yield takeLatest(ifscMasterActions.ADD_IFSC_MASTER_UPLOAD, submitIfscMasterRequestSaga);
}


export function* ifscMasterDataExcelRequest(action) {
    let requestURL = `${CORE_API}/ifsc/master/list/download`;

    try {
        const data = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(ifscMasterActions.ifscMasterDataExcelSuccess({ data: data.data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(ifscMasterActions.ifscMasterDataExcelFailure({ ...err.response, status: "FAILURE" }))
    }
}

export function* ifscMasterDataExcel() {
    yield takeLatest(ifscMasterActions.IFSC_MASTER_DATA_EXCEL_REQUEST, ifscMasterDataExcelRequest);
}

export function* ifscMasterListSaga(action){
  const { pageNumber = DEFAULT_PAGE_NUMBER,pageSize = DEFAULT_PAGE_SIZE, filter = {},sorted = [{ id: "createdAt", desc: true }]} = action.data || {}

  const sortDirection = sorted.desc ? 'desc' : 'asc', sortField = sorted.id || 'createdAt'

  const requestURL = `${CORE_API}/ifsc/masters/list/${pageNumber}/${pageSize}/sort/${sortField}/${sortDirection}`;

  try{
    const response = yield call (request , requestURL,{
        method: 'POST',
        headers: HTTP_HEADERS,
        data: filter

    });

    yield put(ifscMasterActions.ifscMasterListSuccess(response.data))

  }catch(err){
    yield put(
        ifscMasterActions.ifscMasterListFailure(
            err.response?.data || {message:'Failed to fetch Ifsc Master list'}
        )
    );

  }
}

export function* fetchIfscMasterList(){

    yield takeLatest(ifscMasterActions.IFSC_MASTER_LIST_REQUEST , ifscMasterListSaga);

}